import type { ListVouchersQuery } from '~/services/PromoService';

/** Sorts exposed by the voucher list's native DataGrid columns. */
export type VoucherListSortBy = Extract<
  NonNullable<ListVouchersQuery['sortBy']>,
  'voucher_name' | 'created_at' | 'updated_at'
>;
export type VoucherListSortDirection = NonNullable<ListVouchersQuery['sortByDirection']>;

export const VOUCHER_LIST_SORT_FIELD_TO_API_SORT_BY: Record<string, VoucherListSortBy> = {
  voucherName: 'voucher_name',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
};

export const VOUCHER_LIST_API_SORT_BY_TO_FIELD: Record<VoucherListSortBy, string> = {
  voucher_name: 'voucherName',
  created_at: 'createdAt',
  updated_at: 'updatedAt',
};

export function parseVoucherListSortBy(value: string | null): VoucherListSortBy | undefined {
  switch (value) {
    case 'voucher_name':
    case 'created_at':
    case 'updated_at':
      return value;
    default:
      return undefined;
  }
}

export function parseVoucherListSortDirection(value: string | null): VoucherListSortDirection | undefined {
  return value === 'asc' || value === 'desc' ? value : undefined;
}
